var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicessquareheimanButtonsolid = function SvgIcondevicessquareheimanButtonsolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/icon.devices.square.heiman_button.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/icon.devices.square.heiman_button.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF",
    cx: 40,
    cy: 40,
    r: 39.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 40,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    strokeWidth: 0.5,
    cx: 40,
    cy: 38,
    r: 14.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    strokeWidth: 0.5,
    cx: 40,
    cy: 40,
    r: 34.75
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicessquareheimanButtonsolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.square.heiman_button.solid.e013a6560d9ad83ee58303d773d0840d.svg";